// extracted by mini-css-extract-plugin
module.exports =  {"card":"IV4fVNOftpKwZBom6MyH"};